import { useState } from 'react'

import { api, ErrorApi, type CotizacionGuardada, type EstadoComercial } from '../api'
import { fechaCorta } from '../formato'

/**
 * Pendiente / ganada / perdida de ESTA version. Que solo haya una ganada por cliente lo
 * impone la base; si ya hay otra, el servidor dice cual y aqui se muestra tal cual.
 */

export const ETIQUETA_ESTADO: Record<EstadoComercial, string> = { pendiente: 'Pendiente', ganada: 'Ganada', perdida: 'Perdida' }
export const CLASE_ESTADO: Record<EstadoComercial, string> = {
  pendiente: 'insignia-pendiente',
  ganada: 'insignia-cliente',
  perdida: 'insignia-rechazado',
}

interface Props {
  cotizacion: CotizacionGuardada
  alCambiar: (actualizada: CotizacionGuardada) => void
}

export function EstadoVersion({ cotizacion, alCambiar }: Props) {
  const [error, setError] = useState('')
  const [guardando, setGuardando] = useState(false)

  const marcar = async (estado: EstadoComercial) => {
    if (estado === cotizacion.estado) return
    setError('')
    setGuardando(true)
    try {
      alCambiar((await api.marcarEstado(cotizacion.id, estado)).cotizacion)
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo cambiar el estado.')
    } finally {
      setGuardando(false)
    }
  }

  return (
    <div className="bloque-descuento estado-version">
      <span className="fuerte">Estado comercial:</span>
      <div className="filtros">
        {(['pendiente', 'ganada', 'perdida'] as const).map((e) => (
          <button key={e} className={e === cotizacion.estado ? 'chip activo' : 'chip'} disabled={guardando} onClick={() => marcar(e)}>
            {ETIQUETA_ESTADO[e]}
          </button>
        ))}
      </div>
      {cotizacion.estado_at && <small className="ayuda">Marcada el {fechaCorta(cotizacion.estado_at)}</small>}
      {error && <small className="error-en-linea">{error}</small>}
    </div>
  )
}
